import { LOCALE_ID, Pipe, PipeTransform, inject } from "@angular/core";
import { getStoredTranslationsOrEmpty } from "@app/translation-cache";

export interface Country {
  countryCode: string;
}

@Pipe({
  standalone: true,
  name: "mapCountryName",
})
export class MapCountryNamePipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  transform(countryCode: string): string {
    const translations = getStoredTranslationsOrEmpty(this.localeId);

    if (translations && translations[`country.${countryCode.toLowerCase()}`]) {
      return translations[`country.${countryCode.toLowerCase()}`];
    }
    return countryCode;
  }
}
